// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__2V6WI","footer":"ModalInfo_footer__6Jg0m"};